<template>
  <v-card class="elevation-4 ma-3" >
    <request-status :request="req" />
    <v-card-title class="overline py-1 grey lighten-4" >Set your username
      <v-spacer/>
    </v-card-title>
    <v-divider />
    <v-alert text tile dense type="info" class="caption" >
      You cannot change your username once set. So make sure you pick a good one!
    </v-alert>
    <v-card-text >
      <v-text-field filled
        v-model="username"
        label="username" />

      <ul>
        <li>{{username}}.appt.guru will be reserved for you</li>
        <li v-if="context==='practitioner'" >
          Email address: {{username}}@appt.guru will forward to your preferred email
        </li>
      </ul>

    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        @click="save"
        :loading="req.loading"
        color="primary" >Set username</v-btn>
    </v-card-actions>
    <!-- <pre v-text="payload" /> -->
  </v-card>
</template>

<script>
export default {
  name: 'SetUsername',
  props: {
    initialUsername: { type: String, required: true },
    locked: { type: Boolean, default: false },
    objectId: { required: true },
    context: { type: String, required: true },
  },
  data () {
    return {
      username: '',
      req: {
        resource: 'ag.team',
        extra: 'set_username',
        method: 'post'
      }
    }
  },
  watch: {
    initialUsername: {
      immediate: true,
      handler () {
        this.username = this.initialUsername
      }
    }
  },
  computed: {
    payload () {
      let data = {
        context: this.context,
        username: this.username,
      }
      if (this.context === 'space') { data.space = this.objectId }
      if (this.context === 'practitioner') { data.practitionerId = this.objectId }
      return data
    }
  },
  methods: {
    save () {
      this.req.data = this.payload
      this.$request('save', this.req)
    }
  }
}
</script>
